export default "__VITE_ASSET__jr9TZGYf__"